import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import {
  updateAccount,
  getApiKeys,
  removeApiKey,
  createApiKey,
  clearCreatedApiKey,
} from 'store/actions/account';
import { entityNames } from 'config/constants';
import StackSettings from 'components/StackSettings/StackSettings';

const mapStateToProps = (state) => {
  return {
    currentUser: state.currentUser,
    currentAccount: state.accounts.currentAccount,
    apiKeys: state.accounts.apiKeys,
    createdApiKey: state.accounts.createdApiKey,
    isFetching: state.entities[entityNames.CREATE_API_KEY]
      ? state.entities[entityNames.CREATE_API_KEY].isFetching
      : false,
    isLoadingApiKeys: state.entities[entityNames.GET_API_KEYS]
      ? state.entities[entityNames.GET_API_KEYS].isFetching
      : false,
  };
};

export default withTranslation()(
  connect(mapStateToProps, {
    updateAccount,
    getApiKeys,
    removeApiKey,
    createApiKey,
    clearCreatedApiKey,
  })(StackSettings),
);
